import React, { useState } from "react";
import AirportConveyanceModal from "../AirportConveyanceModal";
import GuestBookingModal from "../GuestBookingModal";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import styles from "./2BedInfoCard.module.css";
import { FaUsers, FaWifi, FaBed, FaBath, FaSnowflake } from "react-icons/fa";
import { MdTv } from "react-icons/md";

const InformationCard = () => {
  const [showConveyanceModal, setShowConveyanceModal] = useState(false);
  const [hasConveyance, setHasConveyance] = useState(false);
  const [conveyanceData, setConveyanceData] = useState(null);
  const [showCalendar, setShowCalendar] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [agreedToTerms, setAgreedToTerms] = useState(false);
  const [errors, setErrors] = useState({});
  const [showGuestModal, setShowGuestModal] = useState(false);
  const [guestInfo, setGuestInfo] = useState(null);

  const userIsLoggedIn = false; // ← Replace with actual auth check

  const formatDate = (date) =>
    date?.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = {};
    if (!startDate || !endDate) {
      newErrors.dates = "Please select a date range.";
    }
    if (!agreedToTerms) {
      newErrors.terms = "You must agree to the terms.";
    }

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    if (!userIsLoggedIn && !guestInfo) {
      setShowGuestModal(true);
      return;
    }

    const payload = {
      startDate,
      endDate,
      conveyance: hasConveyance ? conveyanceData : null,
      guest: userIsLoggedIn ? null : guestInfo,
    };

    console.log("Submitting booking info:", payload);
    // TODO: Send this to backend
  };

  const handleGuestSubmit = (guestData) => {
    setGuestInfo(guestData);
    setShowGuestModal(false);

    setTimeout(() => {
      const fakeEvent = { preventDefault: () => {} };
      handleSubmit(fakeEvent);
    }, 100);
  };

  const isFormValid = startDate && endDate && agreedToTerms;

  return (
    <form className={styles.infoCard} onSubmit={handleSubmit}>
      <h2 className={styles.infoTitle}>2 Bedroom Studio Apartment</h2>
      <p className={styles.infoPrice}>₦450,000.00 Per Month</p>
      <p className={styles.infoAvailable}>4 AVAILABLE</p>

      <p className={styles.infoDescription}>
        A cozy yet stylish space featuring a King-size bed, modern furnishings,
        and a private en-suite bathroom with premium toiletries. Enjoy
        high-speed Wi-Fi, a smart TV, and 24/7 room service for a seamless stay.
        Perfect for both leisure and business travelers.
      </p>

      <ul className={styles.infoFeaturesGrid}>
        <li>
          <FaUsers size={16} /> 2 Guests
        </li>
        <li>
          <FaWifi size={16} /> WiFi
        </li>
        <li>
          <FaBed size={16} /> King-size bed
        </li>
        <li>
          <FaBath size={16} /> Private bathroom
        </li>
        <li>
          <MdTv size={16} /> Smart TV
        </li>
        <li>
          <FaSnowflake size={16} /> Air conditioning
        </li>
      </ul>

      <p className={styles.infoSubtext}>
        Best for solo travelers or budget-conscious guests
      </p>

      <div className={styles.infoFlexRow}>
        <div className={`${styles.infoInputGroup} ${styles.datePickerGroup}`}>
          <label className={styles.inputLabel}>DATES</label>
          <input
            readOnly
            onClick={() => setShowCalendar(!showCalendar)}
            value={
              startDate && endDate
                ? `${formatDate(startDate)} - ${formatDate(endDate)}`
                : "Select date range"
            }
          />
          {errors.dates && <p className={styles.formError}>{errors.dates}</p>}

          {showCalendar && (
            <div className={styles.calendarWrapper}>
              <DatePicker
                onChange={(dates) => {
                  if (Array.isArray(dates)) {
                    const [start, end] = dates;
                    setStartDate(start);
                    setEndDate(end);
                  }
                }}
                startDate={startDate}
                endDate={endDate}
                selectsRange
                inline
                minDate={new Date()}
              />
              <button
                className={styles.calendarConfirmBtn}
                type="button"
                onClick={() => setShowCalendar(false)}
              >
                Confirm
              </button>
            </div>
          )}
        </div>

        <div className={styles.infoInputGroup}>
          <div className={styles.conveyanceToggle}>
            <label className={styles.inputLabel}>AIRPORT CONVEYANCE (Optional)</label>
            <label className={styles.switchToggle}>
              <input
                type="checkbox"
                checked={hasConveyance}
                onChange={() => {
                  if (!hasConveyance) {
                    setShowConveyanceModal(true);
                  } else {
                    setHasConveyance(false);
                    setConveyanceData(null);
                  }
                }}
              />
              <span className={`${styles.slider} ${styles.round}`}></span>
            </label>
          </div>
          {conveyanceData ? (
            <div className={styles.conveyanceSummary}>
              <span>
                <span>Date</span>
                <span className={styles.value}>{conveyanceData.date}</span>
              </span>
              <span>
                <span>Time</span>
                <span className={styles.value}>{conveyanceData.time}</span>
              </span>
              <span>
                <span>Phone</span>
                <span className={styles.value}>{conveyanceData.phone}</span>
              </span>
              <span>
                <span>Airport</span>
                <span className={styles.value}>{conveyanceData.airport}</span>
              </span>
            </div>
          ) : (
            <input readOnly value="None" />
          )}

          <p className={styles.infoExtra}>+ ₦5,000 for pickup</p>
        </div>
      </div>

      <button type="submit" className={styles.guestBtn} disabled={!isFormValid}>
        BOOK NOW
      </button>

      <div className={styles.policyCheck}>
        <input
          type="checkbox"
          id="terms"
          checked={agreedToTerms}
          onChange={(e) => setAgreedToTerms(e.target.checked)}
        />
        <label htmlFor="terms">
          I agree to the Terms of Stay and Residency Policies
        </label>
      </div>
      {errors.terms && <p className={styles.formError}>{errors.terms}</p>}
      <p className={styles.policyLink}>[ View Policies ]</p>

      <AirportConveyanceModal
        isOpen={showConveyanceModal}
        onClose={() => setShowConveyanceModal(false)}
        onConfirm={(data) => {
          setConveyanceData(data);
          setHasConveyance(true);
          setShowConveyanceModal(false);
        }}
      />

      <GuestBookingModal
        isOpen={showGuestModal}
        onClose={() => setShowGuestModal(false)}
        onGuestSubmit={handleGuestSubmit}
      />
    </form>
  );
};

export default InformationCard;
